(() => {
  angular
    .module('gm.common.services')
    .factory('gmCsv', gmCsvFactory);

  function gmCsvFactory(
    $window,
    $document
  ) {
    'ngInject';

    return {
      exportCSV,
    };

    function exportCSV(element, filename) {
      const elm = $document[0].getElementById(element);
      const table = angular.element(elm);
      const data = tableToCSV(table);
      const link = $document[0].createElement('a');

      link.download = filename;
      link.href = `data:,${escape(data)}`;
      link.click();
    }

    function mapRow(row) {
      const tds = angular.element(row).find('td[data-csv-export!="false"]');
      const stringRow = $window.$.map(tds, mapText).join(',');

      return `${stringRow}\n`;
    }

    function mapText(elm) {
      const text = angular.element(elm).text().trim()
        .replace(/\s+/g, ' ');

      return `"${text}"`;
    }

    function tableToCSV(table) {
      const th = table.find('thead').find('th');
      const thData = `${$window.$.map(th, mapText).join(',')}\n`;
      const rows = table.find('tbody').find('tr[data-csv-export!="false"]');
      const rowsData = $window.$.map(rows, mapRow).join('');

      return `${thData}${rowsData}`;
    }
  }
})();
